// extracted by mini-css-extract-plugin
export default {"walletCard":"bank_walletCard__YSnCs","interactionsCard":"bank_interactionsCard__xOH40","addressInput":"bank_addressInput__iEPxH","button6":"bank_button6__nIx-n"};